export enum DashboardPanelType {
    ALARMS = 'alarms',
    CHANNEL_GROUP = 'channel-group',
    CUSTOM_GROUP = 'custom-group',
    TREND_GRAPH = 'trend-graph',
    MIMICS = 'mimics',
}
